import type { AppStateStatus } from 'react-native';

type Props = {
	current: AppStateStatus;
	next: AppStateStatus;
};

const backgroundRegExp = /inactive|background/;
const foregroundRegExp = /active/;

const AppStateHelper = {
	isForegrounded({ current, next }: Props): boolean {
		return !!current.match(backgroundRegExp) && !!next.match(foregroundRegExp);
	},

	isBackgrounded({ current, next }: Props): boolean {
		return !!current.match(foregroundRegExp) && !!next.match(backgroundRegExp);
	},
};

export default AppStateHelper;
